import '../css/app.css';
import './bootstrap';

import * as Sentry from '@sentry/vue';

import { autoAnimatePlugin } from '@formkit/auto-animate/vue';
import '@fortawesome/fontawesome-pro/css/all.css';

import { createInertiaApp, Link, Head, usePage, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const options = {
	confirmButtonColor: '#ef4444',
	confirmButtonText: 'Supprimer',
};
import { DateTime, Settings } from 'luxon';
import VueApexCharts from 'vue3-apexcharts';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

// Components
import formButton from '@/Components/Form/FormButton.vue';
import formInput from '@/Components/Form/FormInput.vue';
import formCheckbox from '@/Components/Form/FormCheckbox.vue';
import formRadio from '@/Components/Form/FormRadio.vue';
import formSearch from '@/Components/Form/FormSearch.vue';
import formSelect from '@/Components/Form/FormSelect.vue';
import formTextarea from '@/Components/Form/FormTextarea.vue';
import formValidationErrors from '@/Components/Form/ValidationErrors.vue';
import uiButton from '@/Components/UI/Button.vue';
import fuseField from '@/Components/UI/FuseField.vue';
import uiAlert from '@/Components/UI/Alert.vue';
import uiDropdown from '@/Components/UI/Dropdown.vue';
import uiInfo from '@/Components/UI/Info.vue';
import uiPaginate from '@/Components/UI/Paginate.vue';
import uiListsContact from '@/Components/UI/Lists/Contact.vue';
import uiListsStructure from '@/Components/UI/Lists/Structure.vue';
import uiListsWaitingContact from '@/Components/UI/Lists/WaitingContact.vue';
import uiListLog from '@/Components/UI/Lists/Log.vue';
import uiListHomeLog from '@/Components/UI/Lists/HomeLog.vue';
import uiModal from '@/Components/UI/Modal.vue';
import uiNavbar from '@/Components/UI/Navbar.vue';
import uiReminder from '@/Components/UI/Reminder.vue';
import uiTitle from '@/Components/UI/Title.vue';
import uiSectionTitle from '@/Components/UI/SectionTitle.vue';
import uiToggle from '@/Components/UI/Toggle.vue';
import logComment from '@/Components/UI/Partials/LogComment.vue';
import logDate from '@/Components/UI/Partials/LogDate.vue';


// Modals
import modalContactCreate from '@/Components/Modals/Contacts/Create.vue';
import modalContactSearch from '@/Components/Modals/Contacts/Search.vue';
import modalContactFuse from '@/Components/Modals/Contacts/Fuse.vue';
import modalContactFae from '@/Components/Modals/Contacts/Fae.vue';
import modalUserCreate from '@/Components/Modals/Users/Create.vue';
import modalUserSearch from '@/Components/Modals/Users/Search.vue';
import modalUserShow from '@/Components/Modals/Users/Show.vue';
import modalStructureFuse from '@/Components/Modals/Structures/Fuse.vue';
import modalStructureCreate from '@/Components/Modals/Structures/Create.vue';
import modalStructureSearch from '@/Components/Modals/Structures/Search.vue';
import modalContratSearch from '@/Components/Modals/Contrats/Search.vue';
import modalRemindersShow from '@/Components/Modals/Reminders/Show.vue';
import modalContactsReport from '@/Components/Modals/Contacts/Report.vue';
import modalStatusCreate from '@/Components/Modals/Setting/Create.vue';
import modalStatusShow from '@/Components/Modals/Setting/Show.vue';
import modalStatusSearch from '@/Components/Modals/Setting/Search.vue';
import modalAdminImportDR from '@/Components/Modals/Admin/ImportDR.vue';

// Partials
import partialAddReminder from '@/Components/UI/Partials/AddReminder.vue';
import partialAddTarget from '@/Components/UI/Partials/AddTarget.vue';
import partialAddAction from '@/Components/UI/Partials/AddAction.vue';
import partialGrowthBox from '@/Components/UI/Partials/GrowthBox.vue';
import partialInfoBox from '@/Components/UI/Partials/InfoBox.vue';
import partialStatsSection from '@/Components/UI/Partials/StatsSection.vue';
import partialContactForm from '@/Components/UI/Partials/ContactForm.vue';
import partialStructureForm from '@/Components/UI/Partials/StructureForm.vue';
import partialMap from '@/Components/UI/Partials/Map.vue';

createInertiaApp({
	title: (title) => `${title} - ${appName}`,
	resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
	progress: {
		color: '#4B5563',
	  },
	setup({ el, App, props, plugin }) {
		const myApp = createApp({ render: () => h(App, props) })
			.use(plugin)
			.use(ZiggyVue, Ziggy)
			.use(autoAnimatePlugin)
			.use(VueApexCharts)
			.use(VueSweetalert2, options)
			.use(Vue3Toastify, {
				autoClose: 3000,
				position: "bottom-left",
				theme: "colored",
			})
			.use(router)
			.component('Link', Link)
			.component('Head', Head)
			.component('form-button', formButton)
			.component('form-input', formInput)
			.component('form-checkbox', formCheckbox)
			.component('form-radio', formRadio)
			.component('form-textarea', formTextarea)
			.component('form-search', formSearch)
			.component('form-select', formSelect)
			.component('form-validation-errors', formValidationErrors)
			.component('ui-button', uiButton)
			.component('ui-fuse-field', fuseField)
			.component('ui-info', uiInfo)
			.component('ui-paginate', uiPaginate)
			.component('ui-reminder', uiReminder)
			.component('ui-title', uiTitle)
			.component('ui-section-title', uiSectionTitle)
			.component('ui-list-log', uiListLog)
			.component('ui-list-home-log', uiListHomeLog)
			.component('ui-navbar', uiNavbar)
			.component('ui-modal', uiModal)
			.component('ui-alert', uiAlert)
			.component('ui-dropdown', uiDropdown)
			.component('ui-lists-structure', uiListsStructure)
			.component('ui-lists-contact', uiListsContact)
			.component('ui-lists-waiting-contact', uiListsWaitingContact)
			.component('ui-toggle', uiToggle)
			.component('modal-create-contact', modalContactCreate)
			.component('modal-search-contact', modalContactSearch)
			.component('modal-search-contrat', modalContratSearch)
			.component('modal-create-user', modalUserCreate)
			.component('modal-search-user', modalUserSearch)
			.component('modal-show-user', modalUserShow)
			.component('modal-create-structure', modalStructureCreate)
			.component('modal-search-structure', modalStructureSearch)
			.component('modal-reminder', modalRemindersShow)
			.component('modal-contacts-report', modalContactsReport)
			.component('modal-fuse-contact', modalContactFuse)
			.component('modal-contact-fae', modalContactFae)
			.component('modal-fuse-structure', modalStructureFuse)
			.component('modal-create-status', modalStatusCreate)
			.component('modal-show-status', modalStatusShow)
			.component('modal-search-status', modalStatusSearch)
			.component('modal-import-dr', modalAdminImportDR)
			.component('partial-add-target', partialAddTarget)
			.component('partial-add-reminder', partialAddReminder)
			.component('partial-add-action', partialAddAction)
			.component('partial-growth-box', partialGrowthBox)
			.component('partial-info-box', partialInfoBox)
			.component('partial-stats-section', partialStatsSection)
			.component('partial-map', partialMap)
			.component('partial-contact-form', partialContactForm)
			.component('partial-structure-form', partialStructureForm)
			.component('log-comment', logComment)
			.component('log-date', logDate);

		window.DateTime = DateTime;
		myApp.config.globalProperties.$d = DateTime;
		myApp.config.globalProperties.$modal = {
			setModalURL: window.setModalURL,
			clearModalURL: window.clearModalURL,
		};

		// Sentry
		// Sentry.init({
		// 	myApp,
		// 	dsn: 'https://8af3d34945a09cb36c024036848be71b@o4508490086678528.ingest.de.sentry.io/4508490089168976',
		// 	integrations: [Sentry.browserTracingIntegration({}), Sentry.replayIntegration()],
		// 	// Tracing
		// 	tracesSampleRate: 1.0, //  Capture 100% of the transactions
		// 	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		// 	tracePropagationTargets: ['localhost', /^https:\/\/crm\.dev\.t\-med\.fr/, /^http:\/\/adiral\-crm\.test/],
		// 	// Session Replay
		// 	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		// 	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
		// });

		myApp.mount(el);
	},
});

window.setModalURL = function (id, type) {
	let queryString = new URLSearchParams(window.location.search);
	queryString.set('id', id);
	queryString.set('type', type);
	window.history.pushState({}, '', `${window.location.pathname}?${queryString}`);
};

window.clearModalURL = function () {
	let queryString = new URLSearchParams(window.location.search);
	queryString.delete('id');
	queryString.delete('type');
	window.history.pushState({}, '', `${window.location.pathname}?${queryString}`);
};